import { ActionIcon, ActionIconProps } from "@mantine/core";
import React from "react";
import classes from "@/styles/actionIcon.module.css";

const IconButton = ({
  children,
  onClick,
  ...props
}: { children: React.ReactNode; onClick?: () => void } & ActionIconProps) => {
  return (
    <ActionIcon
      variant="filled"
      aria-label="link"
      bg="#84A59D"
      className={classes.actionIcon}
      w={48}
      h={48}
      style={{ borderRadius: "100%", border: "1px solid white" }}
      onClick={onClick}
      {...props}
    >
      {children}
    </ActionIcon>
  );
};
export default IconButton;
